import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

var COMP = environment.component.finance;

export interface Element {
    column1: string;
    column2: string;
    column3: string;
    column4: string;
    column5: string;
    column6: string;
    column7: string;
    column8: string;
    column9: string;
  }

  const ELEMENT_DATA: Element[] =[
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "6",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "What mechanisms are used to maintain high standards of integrity in the interactions with the private sector?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "4",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "What measures are in place to ensure that procurement practitioners meet high professional standards of knowledge and that their skills are regularly updated?",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D7",
      column6: "No",
      column7: "Absorption of external funds",
      column8: "What is the percentage utilized of official donor capital commitments for WASH (three-year average)?",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D8",
      column6: "No",
      column7: "Domestic absorption",
      column8: "What is the estimated percentage utilized of domestic capital commitments (three-year average)?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "5",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "What institutions and procedures are in place to protect procurement officials from undue influence and promote integrity among officials?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "6",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "To ensure transparency, are the same accounting policies used for all fiscal reports, with a summary of relevant policies, disclosure of deviations from generally accepted practices, and comparable data between reporting periods?",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "There is the ability to have multi-year budget allocations",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Capacity to attract different funding sources",
      column8: "There is a ready pipeline of bankable projects",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "There is a clearly articulated procurement process",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "There is a body that represents the needs of WASH citizens in the budgeting processes",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Capacity to attract different funding sources",
      column8: "There are legal and institutional frameworks for financial transactions to take place",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Capacity to attract different funding sources",
      column8: "The present financing flows and sources (tariffs, taxes and transfers) are known",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Service providers are financially sustainable",
      column8: "The percentage of costs of service providers that are covered by revenues is known",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Capacity to attract different funding sources",
      column8: "The percentage of aid that supports nationally defined plans and budgets is known",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "The funding for WASH in schools, health centres and national sensitization campaigns has been explicitly addressed in the budgeting process and is adequate",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "The budget utilization rate (i.e. the ratio between expenditure and budget) over the last three years is known and higher than 90 percent",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "The budget and expenditure are publicly available",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "The budget and expenditure are known and disaggregated between each of the sub-sectors (rural, urban, water, sanitation)",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Service providers are financially sustainable",
      column8: "The budget allocations and expenditure to the poorest or vulnerable groups is known",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Service providers are financially sustainable",
      column8: "Tariff setting takes into account the most disadvantaged",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Service providers are financially sustainable",
      column8: "Sector providers are internalising externalities: costs account for source protection, conservation and waste management",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Capacity to attract different funding sources",
      column8: "Public allocations to water and sanitation as a percentage of GDP are known",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "Long-term (at least 3 years) commitments are known",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "7",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is the government’s draft budget submitted for parliamentary scrutiny and approved in a timely fashion, and does the executive budget proposal contain all necessary supporting documents for the legislature to take an informed decision? Do additional budget reports provide information on the government’s long-term objectives, assumptions, compliance with the level of revenue and expenditure authorised by the Parliament, and long-term sustainability?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "1",
      column6: "Yes",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is the budget comprehensive, encompassing all government revenue and expenditure, along with detailed commentary and non-financial performance data, including targets, where practicable?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "10",
      column6: "Yes",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is the accountability ensured through year-end fiscal report and an external audit by the Supreme Audit Institution? Are the audit reports scrutinised by Parliament, and does it have the opportunity and resources to effectively examine any fiscal report that it deems necessary?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "9",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is public scrutiny facilitated by making relevant fiscal reports publicly available, free and online? Does the ministry of finance actively promote an understanding of the budget process?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "3",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is expenditure classification done by major function, economic and administrative units, with description as appropriate? Are the total amounts of contingent liabilities disclosed and classified by major category, where feasible, or listed and described where they cannot be quantified?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "5",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is a sensitivity analysis made of the impact of changes in the key economic assumptions, as well as interest rates and foreign exchange rate assumptions? Are the economic assumptions accurately presented",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D9",
      column6: "No",
      column7: "External funding",
      column8: "How are donor funds channeled to the sector? [choices supplied]",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "8",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Have appropriate measures been implemented to reduce the risks of bid-rigging in public procurement and to facilitate the detection of bid-rigging in public procurement?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "1",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Has your country committed to the international standards on transparency and exchange of information in tax matters?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "9",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Has the government established a clear chain of responsibility for contracting decisions and effective control mechanisms?",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D1",
      column6: "No",
      column7: "Financing Plan",
      column8: "Has the government defined a financing plan/budget for the WASH sector, and health sector (for WASH in health care facilities), clearly assessing the available sources of finance and strategies for financing future needs [choices supplied]",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D2",
      column6: "No",
      column7: "Financing Plan",
      column8: "Government budget specific to WASH :  a) Please list ministries/national institutions with responsibilities in WASH and their WASH budgets, b) Please indicate the time period (e.g. financial year) for budget indicated, c) Please indicate currency/units for budget stated above, d) If unable to respond to budget information in format requested above, please provide annual WASH budget indicating what sub-sectors e.g. drinking-water or sanitation are covered by ministries, e) If annual budget information is not available, please explain why, f) Please indicate reasons for significant differences between budget and expenditures",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D10",
      column6: "No",
      column7: "Sufficient finance to meet targets",
      column8: "Going forward, do you estimate that financing allocated to water/sanitation/hygiene improvements are sufficient to national targets? [choices supplied]",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Capacity to attract different funding sources",
      column8: "Functional financial mechanisms and instruments (i.e. credit enhancement to less credit worthy) are being used",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D11",
      column6: "No",
      column7: "Financial Flows",
      column8: "Financial flows for sanitation, drinking-water, and hygiene promotion [choices supplied]",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Service providers are financially sustainable",
      column8: "Existing incentives for environmentally sustainable efficient technologies",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Capacity to attract different funding sources",
      column8: "Existence of financing institutions that support the sector",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Capacity to attract different funding sources",
      column8: "Existence of a domestic bond market",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "8",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Does your country have in place legal mechanisms for the exchange of information for tax purposes with other countries and do these mechanisms allow for the use of information received under these mechanisms for other purposes involving serious crimes such as the prosecution of corruption cases?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "4",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Does your country have enforcement provisions to ensure the availability of ownership and accounting information?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "5",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Does your country ensure the availability of banking information for all account holders and does it provide access to banking information for tax purpose?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "3",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Does your country ensure availability of reliable accounting information?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "2",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Does your country ensure availability of ownership and identity information for companies, partnerships, trusts and foundations?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "2",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Does the budget provide comparative information on revenues and expenditures for the immediate past and future (e.g. actual expenditures and forecasts as well as the budget request)?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "6",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Do the (tax) authorities have sufficient powers to obtain and provide information from any person within their territorial jurisdiction who is in control or possession of such information?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "10",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Do governments handle complaints from potential suppliers in a fair and timely manner? What are the available recourse mechanisms for potential suppliers?",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "Budget adequacy: the budget and expenditure for recurrent costs to provide adequate support to the delivery of (basic) services are known",
      column9: ""
    },
    {
      column1: "Basic : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "Budget adequacy: the budget and expenditure for capital expenditure to meet national water sector investment targets are known",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D5",
      column6: "Yes",
      column7: "Equity",
      column8: "Are there specific measures in the financing plan to target resources to reduce inequities in access and levels of service and are they being applied for the following? [choices supplied]",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D6",
      column6: "No",
      column7: "Affordability",
      column8: "Are there financial schemes to make access to WASH more affordable for vulnerable groups?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "2",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Are there clear rules to guide the choice of a procurement method that optimises transparency? Are there mitigation measures in place to prevent risks to integrity, in particular in exceptions to competitive tendering?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "7",
      column6: "No",
      column7: "Tax transparency: creating a level playing field",
      column8: "Are there appropriate limits on professional secrecy in your jurisdiction? Is legal professional privilege limited to confidential communications between attorneys, solicitors or other legal representatives in their role as such and their clients?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "1",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Are public procurement rules and procedures designed in a way to ensure an adequate degree of transparency in order to promote fair and equitable treatment of potential suppliers while avoiding red tape?",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D4",
      column6: "No",
      column7: "Cost Recovery Strategies",
      column8: "Are operations and basic maintenance covered by tariffs or household contributions? [choices supplied]",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "3",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Are mechanisms in place to ensure that needs are adequately estimated and public funds are used according to the purposes intended?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "4",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Are key financial data and economic assumptions disclosed explicitly, and are financial assets -including assets belonging to employee pension plans -valued at market value?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "7",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Are internal control mechanisms used to track decisions and help identify potential corruption in public procurement? Are sanctions applied in case of breach in a proportional and timely manner?",
      column9: ""
    },
    {
      column1: "GLAAS Country Survey – Long Form, UNICEF and WHO",
      column2: "http://www.who.int/water_sanitation_health/monitoring/investments/glaas-2016-2017-cycle/en/",
      column3: "None found",
      column4: "None",
      column5: "D3",
      column6: "Yes",
      column7: "Financial reporting",
      column8: "Are expenditure reports publicly available and easily accessible, and do they allow actual spending on WASH to be compared with committed funding?",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "11",
      column6: "No",
      column7: "Public procurement: preventing waste",
      column8: "Are civil society organisations, media and the wider public empowered to scrutinise public procurement?",
      column9: ""
    },
    {
      column1: "Developed : IRC WASH Financial indicators for water and sanitation at national level",
      column2: "http://www.ircwash.org/blog/financial-indicators-water-and-sanitation-national-level-what-do-we-really-need-know",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "Adequacy of financial flows to meet universal targets",
      column8: "Allocations to sub-national level incorporate equity criteria (to be defined by each country)",
      column9: ""
    },
    {
      column1: "Toolkit for Integrity: OECD",
      column2: "http://www.oecd.org/gov/regional-policy/integrity-in-the-water-sector.htm",
      column3: "None found",
      column4: "None",
      column5: "8",
      column6: "No",
      column7: "Public financial management: ensuring transparent budgets",
      column8: "Is a dynamic system of internal financial controls in place to ensure the integrity of fiscal reports? Does each report contain a statement of responsibility by the finance minister and the senior official responsible for producing the report?",
      column9: ""
    },
    {
      column1: "Financing for Water and Sanitation Resources - EU Water Intiative (EUWI)",
      column2: "www.gwp.org/en/About-GWP/Publications/EU-Water-Initiative/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Strategic Financial Planning (SFP) - Global Water Partnership",
      column2: "http://www.gwp.org/en/learn/iwrm-toolbox/The-Enabling-Environment/Investment-and-Financing-Structures/Strategic-financial-planning/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "WASHCost Calculator - IRC",
      column2: "www.ircwash.org/washcost",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "FEASIBLE - Financing for Environmental, Affordable and Strategic Investments that Bring on Large-scale Expenditure (FEASIBLE) - OECD",
      column2: "www.oecd.org/water",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Strategic Financial Planning for Water Supply and Sanitation - OECD",
      column2: "www.oecd.org/env/resources/drinkingwatersupplyandsanitation.htm",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Creditor Reporting System- OECD",
      column2: "stats.oecd.org/Index.aspx?DataSetCode=CRS1",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "WASH Bottleneck Analysis Tool (WASH-BAT) - UNICEF",
      column2: "watersdgtoolbox.org/tools/199-wash-bottleneck-analysis-tool-washbat",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "CSO/SDA/MAPAS scorecard - World Bank  Water and  Sanitation Program (WSP)",
      column2: "www.sanitationmonitoringtoolkit.com/sanitation-monitoring-toolkit/monitoring-the-enabling-environment#t1t1",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Economics of Sanitation Initiative - WSP",
      column2: "https://www.wsp.org/content/economic-impacts-sanitation",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Guidelines for User Fees and Cost Recovery – For Rural, Non-networked Water and Sanitation Delivery  - WSP",
      column2: "http://www.ircwash.org/sites/default/files/ADB-2010-Guidelines-Rural.pdf",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "IBNET benchmarking toolkit - WSP",
      column2: "www.ib-net.org",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "IBNET water supply and sanitation performance blue book - WSP",
      column2: "http://documents.worldbank.org/curated/en/420251468325154730/The-IBNET-water-supply-and-sanitation-performance-blue-book",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Millennium Development Goals costing and financing spreadsheet - WSP",
      column2: "http://akvopedia.org/wiki/MDG_Costing_and_Financing",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Sector Wide Investment and Financing Tool (SWIFT) - WSP",
      column2: "http://akvopedia.org/wiki/SWIFT",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Global Water Tool - World Business Council for Sustainable Development",
      column2: "http://old.wbcsd.org/work-program/sector-projects/water/global-water-tool.aspx",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "The System of Environmental-Economic Accounting for Water (SEEA-Water) -United Nations Statistical Commission",
      column2: "http://unstats.un.org/unsd/envaccounting/seeaw/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Global Analysis and Assessment of Sanitation and Drinking-Water (GLAAS) - WHO/UN-Water",
      column2: "www.who.int/water_sanitation_health/monitoring/investments/glaas/en/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "TrackFin - WHO",
      column2: "http://www.who.int/water_sanitation_health/glaas/trackfin/en/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "Yes",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Public Expenditure and Financial Accountability (PEFA)",
      column2: "www.pefa.org",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Safely Managed Water Supply Services: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching entire population (or national aspiration) to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Basic Water Supply Services: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching entire population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Ending Open Defecation: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching entire population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Safely Managed Sanitation Services: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching entire population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Basic Sanitation Services: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching entire population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Safely Managed Hygiene Services: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching entire population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Basic Hygiene Services: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Safely Managed Water Supply Services: Annual capital costs of extending services to 2015 unserved population",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Ending Open Defecation: Annual capital costs of maintaining services for already served population in 2015",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Basic Water Supply Services: Annual capital costs of extending services to 2015 unserved population",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Safely Managed Sanitation Services: Annual capital costs of extending services to 2015 unserved population",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Basic Sanitation Services: Annual capital costs of extending services to 2015 unserved population",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Safely Managed Hygiene Services: Annual capital costs of extending services to 2015 unserved population",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Summary capital costs, annualized",
      column8: "Universal Basic Hygiene Services: Annual capital costs of extending services to 2015 unserved population",
      column9: "Annual capital costs of reaching unserved population to achieve universal access of different service levels by 2030 ('000,000 US$)"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "F1dw",
      column6: "Yes, only for 6.1 and 6.2",
      column7: "Summary capital costs, water supply",
      column8: "Total capital costs for universal coverage for safely managed water supply services to 2030",
      column9: "Go to tab \"SDG COSTING SUMMARY REPORT ($)\" and add together numbers at:\nG76 [Universal Basic Water Supply Services: Annual capital costs of extending services to 2015 unserved population] + K76 [Universal Safely Managed Water Supply Services: Annual capital costs of extending services to 2015 unserved population] + G77 [Universal Basic Water Supply Services:  Annual capital costs of maintaining services for already served population in 2015] + K77 [Universal Safely Managed Water Supply Services: Annual capital costs of maintaining services for already served population in 2015] * 15 [to change form annualised to total cost]"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "F1ds",
      column6: "Yes, only for 6.1 and 6.2",
      column7: "Summary capital costs, sanitation and hygiene",
      column8: "Total capital costs for universal coverage for safely managed sanitation and basic hygiene services to 2030",
      column9: "Go to tab \"SDG COSTING SUMMARY REPORT ($)\" and add together numbers at 1d Data Summary: \nF76 [Ending Open Defecation: Annual capital costs of extending services to 2015 unserved population] + F77 [Ending Open Defecation: Annual capital costs of maintaining services for already served population in 2015] + H76 [Universal Basic Sanitation Services: Annual capital costs of maintaining services for already served population in 2015] + H77 [Universal Basic Sanitation Services: Annual capital costs of maintaining services for already served population in 2015] + L76 [Universal Safely Managed Sanitation Services: Annual capital costs of extending services to 2015 unserved population] + L77 [Universal Safely Managed Sanitation Services: Annual capital costs of maintaining services for already served population in 2015] + I76 [Universal Basic Hygiene Services: Annual capital costs of  extending services to 2015 unserved population] + I77 [Universal Basic Hygiene Services: Annual capital costs of maintaining services for already served population in 2015]* 15 [to change from annualised to total cost]"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "F4w",
      column6: "Yes, only for 6.1 and 6.2",
      column7: "Cost by year: Total capital costs, water supply",
      column8: "Capital costs 2016  for universal coverage for safely managed swater supply services to 2030",
      column9: "Go to tab \"SDG COSTING SUMMARY REPORT ($)\" and add together numbers at 4. Costs per year: \nFigure 4a [Basic water supply 2016] + [Safely managed water supply 2016] + Figure 4b [Basic water supply 2016] + [safely managed water supply 2016]"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "F4s",
      column6: "Yes, only for 6.1 and 6.2",
      column7: "Cost by year: Total capital costs, sanitation and hygiene services",
      column8: "Capital costs 2016  for universal coverage for safely managed sanitation and basic hygiene services to 2030",
      column9: "Go to tab \"SDG COSTING SUMMARY REPORT ($)\" and add together numbers at 4. Costs per year: \nFigure 4a [Basic sanitation 2016] + [Safely managed sanitation 2016] + [Handwashing station] + Figure 4b [Basic sanitation 2016] + [Safely managed sanitation 2016] + [Handwashing station] + [fixed point defecation]"
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Population size in urban and rural areas, form 2015 to 2030 and coverage of WASH services in 2015",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Population to serve, based on population size and proportion of population unserved",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Annual capital costs as a percent of GDP - for both extending services and maintaining existing services",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "Data for 140 countries are incorporated into the tool for 6.1 and 6.2",
      column4: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column5: "",
      column6: "No",
      column7: "Cost breakdown by capital, capital maintenance and operational - for both extending services and maintaining existing services",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Public funding available for WASH in latest fiscal year available",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Annual financing required form public sources and the consumer - based on cost sharing ratios",
      column8: "",
      column9: ""
    },
    {
      column1: "Sustainable Development Goal Country Costing Model for WASH",
      column2: "http://sanitationandwaterforall.org/news/preparatory-process-for-2017-hlms-kicks-off-with-webinar-series/",
      column3: "None found",
      column4: "None",
      column5: "",
      column6: "No",
      column7: "Funding gap based on available public funding and cost sharing required form public sources",
      column8: "",
      column9: ""
    }
   ];
@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.css']
})
export class FinanceComponent implements OnInit {

// @ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8', 'column9'];
dataSource: MatTableDataSource<Element>;
  constructor(private router: Router) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".finance-click").addClass("header_active")
  }

  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

    addQuestion(){
        this.router.navigateByUrl('/sdg/add-question/'+COMP)
    }
    homeBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
    }
    quesBtnClick(){
        this.router.navigateByUrl('/sdg/finance-quest')
    }
    dataBtnClick(){
        this.router.navigateByUrl('/sdg/finance-data')
    }
    reportBtnClick(){
        this.router.navigateByUrl('/sdg/finance-report')
    }
}



// WEBPACK FOOTER //
// ./src/app/sdg/finance/finance.component.ts